module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_9005.feeb5e14.png";